import { render, staticRenderFns } from "./TypeNavBar.vue?vue&type=template&id=54dff56b&scoped=true&"
import script from "./TypeNavBar.vue?vue&type=script&lang=js&"
export * from "./TypeNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TypeNavBar.vue?vue&type=style&index=0&id=54dff56b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dff56b",
  null
  
)

export default component.exports